require("imports-loader?define=>false!@EvpJsRoutingBundle/Resources/public/js/router.js");
require("@root/web/js/fos_js_routes.js");

class RouterProvider {
    /*@ngInject*/
    $get(environment, language) {
        Routing.setLocale(language.getCurrentLanguage());

        return Routing;
    };
}

export default RouterProvider;
